import { Grid } from "@material-ui/core";
import ConsumptionChart from "../projectDetails/ConsumptionChart";

const ProjectCharts = ({ project }) => {
  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ margin: "10px auto" }}
      >
        <ConsumptionChart
          projectId={project?.water_meter_project_id}
          project={project}
        />
      </Grid>
    </>
  );
};
export default ProjectCharts;
